import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "mb-1 flex flex-wrap gap-1" }
const _hoisted_5 = {
  key: 0,
  class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
}
const _hoisted_6 = {
  key: 1,
  class: "rounded bg-catering-berry-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-berry-600"
}
const _hoisted_7 = {
  key: 0,
  class: "space-y-0.5 text-xs"
}
const _hoisted_8 = { class: "shrink-0 text-catering-ink-500" }
const _hoisted_9 = { class: "min-w-0 break-words text-right text-catering-ink-800" }
const _hoisted_10 = {
  key: 1,
  class: "break-words text-catering-ink-800"
}
const _hoisted_11 = {
  key: 1,
  class: "text-catering-ink-500"
}
const _hoisted_12 = {
  key: 2,
  class: "mt-2 text-[11px] text-catering-ink-500"
}

import { computed } from 'vue'

import { addressDisplayFields } from '@/helpers/botAddressFields'

const MERCHANT_PICKUP_LOCATION = 'merchant_pickup_location'
const CUSTOMER = 'customer'


export default {
  __name: 'BotOrderAddress',
  props: { block: { type: Object, required: true } },
  setup(__props) {

const props = __props

const address = computed(() => props.block.address || {})
const fields = computed(() => addressDisplayFields(props.block.address))

// Keyed off address_belongs_to, never off fulfillment_type alone: on a pickup
// order the address returned is the merchant's own pickup location, and calling
// that "customer address" is the exact mislabel this payload exists to prevent.
const heading = computed(() => {
  if (props.block.address_belongs_to === MERCHANT_PICKUP_LOCATION) return 'Your pickup location'
  if (props.block.address_belongs_to === CUSTOMER) return 'Customer address'
  return 'Order address'
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(heading.value) + " · Order " + _toDisplayString(__props.block.order), 1),
    (__props.block.has_address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (__props.block.fulfillment_type)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.block.fulfillment_type), 1))
              : _createCommentVNode("", true),
            (__props.block.removed_from_address_book)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " removed from address book "))
              : _createCommentVNode("", true)
          ]),
          (fields.value.length)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (f) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: f.label,
                    class: "flex justify-between gap-3"
                  }, [
                    _createElementVNode("dt", _hoisted_8, _toDisplayString(f.label), 1),
                    _createElementVNode("dd", _hoisted_9, _toDisplayString(f.value), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(address.value.single_line), 1))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(__props.block.message || 'No address is saved on this order.'), 1)),
    (__props.block.note)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(__props.block.note), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}